import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    // Bypass auth requirement when arriving via Private Mirror (?from=mirror&t=...)
    const params = new URLSearchParams(location.search);
    const isMirrorGuest = params.get("from") === "mirror" && !!params.get("t");

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ink">
                <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (!user && !isMirrorGuest) {
        const redirect = location.pathname + location.search;
        return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
    }
    return children;
}

export function AdminProtectedRoute({ children }) {
    const token = localStorage.getItem("admin_token");
    if (!token) return <Navigate to="/admin/login" replace />;
    return children;
}

export function SuperAdminProtectedRoute({ children }) {
    const token = localStorage.getItem("superadmin_token");
    if (!token) return <Navigate to="/adminrenova/login" replace />;
    return children;
}
